import { render, staticRenderFns } from "./RatePlanSetup.vue?vue&type=template&id=4fcdd191&scoped=true&"
import script from "./RatePlanSetup.vue?vue&type=script&lang=js&"
export * from "./RatePlanSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcdd191",
  null
  
)

export default component.exports